module.exports = __webpack_public_path__ + "turkmenistan.svg?ab14830f2aa47cc33674c52bc3ce52c2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/turkmenistan.svg
// module id = 325
// module chunks = 10